module.exports = __webpack_public_path__ + "static/media/dyk_0.c1f91a60.svg";